<div class="uk-container">
	<div *ngIf="section" class="ServicesHeading" [ngClass]="section.CODE ? 'ServicesHeading--' + section.CODE : ''">
		<h1 #catalogTitle>{{ h1Text }}</h1>
	</div>
	<div *ngIf="!section" class="ServicesHeading">
		<h1><span class="Placeloader">Lorem ipsum dolor sit amet, consectetur.</span></h1>
	</div>

	<div *ngIf="section && section.UF_FILTER_TAGS.length > 0" class="uk-margin-bottom">
		<catalog-filter-tags [section]="section"></catalog-filter-tags>
	</div>

	<section>
		<div class="uk-margin-xlarge-bottom uk-grid" uk-grid>
			<div class="uk-width-auto@m">
				<catalog-section-filter *ngIf="section"
					[filterProperties]="filterProperties"
					[sectionId]="section.ID"
					[loadingState]="loadingState"
					(filterChange)="changeFilter($event)"
					(orderChange)="changeOrder($event)"
				></catalog-section-filter>

				<div *ngIf="!section" class="CatalogFilter"></div>
			</div>

			<div class="uk-width-expand@m" itemtype="http://schema.org/ItemList" itemscope>
				<catalog-section-items [items]="catalog" [isCatalogReady]="isCatalogReady"></catalog-section-items>

				<div class="CatalogPagination" *ngIf="isPaginationReady">
					<app-pagination
						[loadingState]="loadingState"
						[countPages]="countPages"
						(pageChange)="changePage($event)"
					></app-pagination>
				</div>
				<div class="CatalogDescription" *ngIf="section.DESCRIPTION" [innerHtml]="section.DESCRIPTION"></div>
			</div>
		</div>
	</section>
</div>
<div class="uk-background-muted">
	<div class="uk-container">
		<catalog-promo-slider></catalog-promo-slider>
	</div>
</div>
